import { ReplyInformation } from './../../../../../Models/ReplyInformation';
import { EmailService } from './../../../../../Services/email.service';
import { Helper } from './../../../../../../helpers/helper.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ServiceRequestService } from './../../../../../../back-office/Services/service-request.service';
import { ServiceRequest } from './../../../../../../back-office/Models/ServiceRequest';
import { Subscription } from 'rxjs';
import * as Mustache from 'mustache';

@Component({
  selector: 'app-reply-step-text',
  templateUrl: './reply-step-text.component.html',
  styleUrls: ['./reply-step-text.component.scss']
})
export class ReplyStepTextComponent implements OnInit, OnDestroy {

  @Input() Index;
  @Input() isActive;

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];
  public modules = {};
  public tokens = [];
  public rawTokens: any;

  constructor(
    private requestService: ServiceRequestService,
    public helper: Helper,
    private translate: TranslateService,
    private emailService: EmailService,
  ) {

    this.modules = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],

        [{'header': 1}, {'header': 2}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{'direction': 'rtl'}],

        [{'size': ['small', false, 'large', 'huge']}],
        [{'header': [1, 2, 3, 4, 5, 6, false]}],

        [{'color': []}, {'background': []}],
        [{'align': []}],
        ['link']
      ]
    };

    this.tokens = [
      {description: 'current_user' , name: '{{current_user.fullname}}'},
      {description: 'order_number' , name: '{{order.orderNo}}'},
    ];
  }

  ngOnInit() {
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        this.request.reply.replyItems = this.request.reply.replyItems.filter(item => !item.solutionStep.restricted);
        if (this.request.reply.replyItems[this.Index] && !this.request.reply.replyItems[this.Index].replyInformation) {
          this.request.reply.replyItems[this.Index].replyInformation = new ReplyInformation();
          this.request.reply.replyItems[this.Index].replyInformation.message = this.request.reply.replyItems[this.Index].solutionStep.actionInformation.message;
        }
        this.request.user.fullname = this.request.user.fullName;
        this.rawTokens = {current_user: this.request.user , order: this.request.order};
        this.updateTextBody();
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  clipboardUpdated() {
    this.helper.showNotify('',
      this.translate.instant('admin.emails.manage.copied_to_clipboard'),
      'success'
    );
  }

  updateServiceRequest() {
    this.requestService.serviceRequest.next(this.request);
  }

  confirmStep() {
    const data = this.request.reply.replyItems[this.Index].replyInformation;
    this.subscriptions.push(
      this.requestService.confirmStep({serviceRequest: this.request.id , replyItem: this.request.reply.replyItems[this.Index].id , data: data}).subscribe(res => {
        this.requestService.fetchServiceRequestComplete(this.request.id , false);
      })
    );
  }

  private updateTextBody() {
    this.request.reply.replyItems[this.Index].replyInformation.message = Mustache.render(this.request.reply.replyItems[this.Index].replyInformation.message, this.rawTokens);
  }

}
